import * as React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import PDFCompanyHeader from "./PDFCompanyHeader";
import PDFCompanyFooter from "./PDFCompanyFooter";
import { getMomentDate } from "../constants/constants";
Font.register({
  src: "https://fonts.gstatic.com/s/kadwa/v2/rnCm-x5V0g7ipiTAT8M.ttf",
  family: "KadwaRegular",
});
Font.register({
  src: "https://fonts.gstatic.com/s/kadwa/v2/rnCr-x5V0g7ipix7atM5kn0.ttf",
  family: "KadwaBold",
});
Font.register({
  src:
    "https://fonts.gstatic.com/s/montserrat/v12/JTUSjIg1_i6t8kCHKm459Wlhzg.ttf",
  family: "MontserratRegular",
});
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    // backgroundColor: "#E4E4E4"
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  body: {
    padding: 10,
  },
  table: {
    display: "flex",
    width: "auto",
    margin: 20,
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableColHeader: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 8,
    fontWeight: 500,
  },
  tableCell: {
    margin: 5,
    fontSize: 8,
  },
});
function PDFQuestionaireDataDocument(props: any) {
  const { data } = props;
  let headers = new Array<any>();
  let outsideHeaders = new Array<any>();
  outsideHeaders.push({ analyticsKey: "Employee" });
  outsideHeaders.push({ analyticsKey: "Date" });
  if (data && data.length > 0) {
    headers = outsideHeaders.concat(data[0].questions);
  }
  const getDataForEachPage = (rawData: any) => {
    let data = rawData.sort((a: any, b: any) => {
      if (a.assignedTo.fullName < b.assignedTo.fullName) {
        return -1;
      }
      if (a.assignedTo.fullName > b.assignedTo.fullName) {
        return 1;
      }
      return 0;
    });
    let dataForPage = new Array<any>();
    let numPage = data.length / 8;
    let start = 0;
    for (var i = 0; i < numPage; i++) {
      let pageData = new Array<any>();
      for (var j = start; j < data.length; j++) {
        if (pageData.length < 8) {
          pageData.push(data[j]);
          start = j;
        }
      }
      dataForPage.push({ items: pageData });
    }
    return dataForPage;
  };
  let dataForPage = getDataForEachPage(data);
  return (
    <Document>
      {dataForPage.map((dataItem: any, index: any) => (
        <Page
          size="A4"
          orientation={"landscape"}
          style={styles.page}
          wrap={false}
        >
          <PDFCompanyHeader company={props.company} />
          <View style={styles.table}>
            <View style={styles.tableRow}>
              {headers.map((headerItem: any) => (
                <View style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader}>
                    {headerItem.analyticsKey}
                  </Text>
                </View>
              ))}
            </View>
            {dataItem.items.map((pageData: any, index: any) => (
              <View style={styles.tableRow}>
                {outsideHeaders.map((headerItem: any) => {
                  if (headerItem.analyticsKey === "Employee") {
                    return (
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {pageData.assignedTo.fullName}
                        </Text>
                      </View>
                    );
                  } else {
                    return (
                      <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                          {getMomentDate(pageData.date, "MM-DD-YY")}
                        </Text>
                      </View>
                    );
                  }
                })}
                {pageData.questions.map((questionItem: any) => {
                  return (
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{questionItem.value}</Text>
                    </View>
                  );
                })}
              </View>
            ))}
          </View>
          <PDFCompanyFooter />
        </Page>
      ))}
    </Document>
  );
}
export default PDFQuestionaireDataDocument;
